import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

type PerformanceDataGridDateRangeProps = {
  startDate?: string;
  endDate?: string;
  type?: string;
  redemptionEndTime?: string;
};

const PerformanceDataGridDateRange = ({
  startDate,
  endDate,
  type,
  redemptionEndTime,
}: PerformanceDataGridDateRangeProps) => {
  const { t } = useTranslation();
  if (type === 'Never Expire') return type;
  if (type === 'Dynamic') return redemptionEndTime;
  if (!!startDate && !!endDate)
    return `${formatDateString(startDate)} ${t(
      'forms.fields.dateRange.to',
    )} ${formatDateString(endDate)}`;
  return null;
};

export default PerformanceDataGridDateRange;

const formatDateString = date =>
  DateTime.fromISO(date).toFormat('MMM dd, yyyy');
